<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Organizations &nbsp;
          <add-button link="/system-setup/organizations/create"></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">System Setup</li>
          <li class="breadcrumb-item">Organizations</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body row">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
          <div class="col-md-4">
            <div style="float: right">
              <a
                href="#"
                class="btn btn-primary"
                v-if="Exportorganizations.length == 0"
                @click="exportToExcel"
              >
                <span v-if="isExcelloading">
                  <div class="d-flex align-items-center">
                    <strong>Generating Excel</strong>
                    &nbsp;
                    <div
                      class="
                        spinner-border
                        text-light
                        spinner-border-sm
                        ms-auto
                      "
                      role="status"
                      aria-hidden="true"
                    ></div>
                  </div>
                </span>
                <span v-else>Generate Excel</span>
              </a>
              <download-excel
                :title="title"
                v-else
                class="btn btn-success"
                :data="organizations_excel"
                :fields="excel_fields"
                worksheet="Organizations"
                name="Organization.xls"
                >Download Excel
              </download-excel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Name</th>
                    <th>City</th>
                    <th>Country</th>
                    <th>Phone</th>
                    <th>Fax</th>
                    <th>Address</th>
                    <th>Brief Info</th>
                    <th>Logo</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="organizations.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr
                    v-for="(organization, at) in organizations"
                    :key="`organization${at}`"
                  >
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>{{ organization.name }}</td>
                    <td>
                      {{ organization.city ? organization.city.name : "" }}
                    </td>
                    <td>
                      {{
                        organization.country ? organization.country.name : ""
                      }}
                    </td>
                    <td>{{ organization.phone }}</td>
                    <td>{{ organization.fax }}</td>
                    <td>{{ organization.address }}</td>
                    <td>{{ organization.info }}</td>
                    <td>
                      <img
                        v-if="organization.logo"
                        :src="`${mediaUrl + organization.logo}`"
                        alt=""
                        srcset=""
                      />
                      <span v-else></span>
                    </td>
                    <td>
                      <div>
                        <router-link
                          :to="`/system-setup/organizations/${organization.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(organization.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "organization",
  data() {
    return {
      organizations: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      organizations_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
        City: "city",
        Country: "country",
        Phone: "phone",
        Fax: "fax",
        Address: "address",
        "Brief Info": "info",
      },
      Exportorganizations: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let organizations = await axios.get(
        `/organizations?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.organizations = organizations.data.data;
      this.count = organizations.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let organizations = await axios.get(
        `/organizations?search=${this.searchData}`
      );
      this.organizations = organizations.data.data;
      this.count = organizations.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Organization Data";
      this.organizations_excel = [];
      let Exportorganizations = [];
      Exportorganizations = await axios.get(`/organizations`);
      this.Exportorganizations = Exportorganizations.data.data;
      let sr_no = 1;
      this.Exportorganizations.forEach((organization) => {
        this.organizations_excel.push({
          sr_no: sr_no,
          name: organization.name ? organization.name : "",
          address: organization.address ? organization.address : "",
          country: organization.country ? organization.country.name : "",
          city: organization.country ? organization.city.name : "",
          phone: organization.phone ? organization.phone : "",
          fax: organization.fax ? organization.fax : "",
          info: organization.info ? organization.info : "",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=organizations`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
